import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Check, Close, InfoRounded } from '@material-ui/icons';
import {
  BACKGROUND_DARK, BORDER_DARK, CUSTOM_GREY, GREEN_COLOR,
  LIGHT_GREY_COLOR, ROYAL_BLUE_COLOR, WHITE_COLOR,
} from '../../const/color-const';
import { darken } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const [MOBILE_WIDTH, DESKTOP_WIDTH] = [340, 440];

const useStyles = makeStyles(theme => ({
  snackbarWrapper: {
    background: theme.palette.type === 'light' ? WHITE_COLOR : darken(BACKGROUND_DARK, 0.3),
    boxShadow: theme.palette.type === 'light' ? `0 0 12px 0 ${CUSTOM_GREY}` : `0 0 20px 0 ${BORDER_DARK}`,
    padding: theme.spacing(2, 6, 2, 7),
    maxWidth: MOBILE_WIDTH,
    position: 'fixed',
    overflow: 'visible',
    borderRadius: 8,
    width: '100%',
    right: 'auto',
    left: '50%',
    bottom: 24,
    transform: 'translateX(-50%)',
    [theme.breakpoints.up('md')]: {
      left: `calc(50% + 128px)`,
      maxWidth: DESKTOP_WIDTH,
    },
  },
  
  closeBtn: {
    position: 'absolute',
    background: 'none',
    cursor: 'pointer',
    border: 'none',
    right: 10,
    top: 14,
    '& > svg': {
      color: LIGHT_GREY_COLOR,
      height: 20,
    },
  },
  snackbarContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    '& > p': {
      margin: theme.spacing(0.2),
    },
  },
  snackbarIcon: props => ({
    color: props.snackbarType === NOTIFICATION_TYPE ? ROYAL_BLUE_COLOR : GREEN_COLOR,
    position: 'absolute',
    height: 24,
    left: 18,
    top: 16,
  }),
  title: props => ({
    color: props.snackbarType === NOTIFICATION_TYPE ? ROYAL_BLUE_COLOR : GREEN_COLOR,
    fontWeight: 'bold',
  }),
  message: props => ({
    color: props.snackbarType === NOTIFICATION_TYPE ? ROYAL_BLUE_COLOR : GREEN_COLOR,
  }),
}));

export const [NOTIFICATION_TYPE, SUCCESS_TYPE] = ['notification', 'success'];

const CommonSnackbar = ({ open, title, message, timeframe = 6000, snackbarType, onExtraClose }) => {
  const [snackbarStatus, setSnackbarStatus] = React.useState(open);
  const classes = useStyles({ snackbarType: snackbarType });
  
  React.useEffect(() => {
    setSnackbarStatus(open);
  }, [open]);
  
  const handleRequestClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if (onExtraClose) {
      onExtraClose();
    }
    setSnackbarStatus(false);
  };
  
  return (
    <Snackbar
      open={snackbarStatus}
      autoHideDuration={timeframe}
      onClose={handleRequestClose}
      className={classes.snackbarWrapper}>
      <>
        {snackbarType === NOTIFICATION_TYPE
          ? <InfoRounded className={classes.snackbarIcon} />
          : <Check className={classes.snackbarIcon} />}
  
        <div className={classes.snackbarContent}>
          <p className={classes.title}>{title}</p>
          <p className={classes.message}>{message}</p>
        </div>
        <button className={classes.closeBtn} onClick={() => setSnackbarStatus(false)}>
          <Close />
        </button>
      </>
    </Snackbar>
  );
};

CommonSnackbar.defaultProps = {
  snackbarType: NOTIFICATION_TYPE,
  timeframe: 8000,
};

CommonSnackbar.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.object,
  message: PropTypes.object,
  timeframe: PropTypes.number,
  snackbarType: PropTypes.string,
  onExtraClose: PropTypes.func,
  machines: PropTypes.array,
};

export default CommonSnackbar;